<template>
    <div id="app">
        <v-header></v-header>
        <v-logo></v-logo>
        <v-nav></v-nav>
        <v-breadcrumb></v-breadcrumb>
        <router-view class="router-view"></router-view>
        <v-footer></v-footer>
    </div>
</template>

<script>
import Header from './components/Header';
import Footer from './components/Footer';
import Logo from './components/Logo';
import Nav from './components/Nav';
import Breadcrumb from './components/Breadcrumb';

import { mapActions } from 'vuex';

export default {
    name: 'app',
    components: {
        'v-header': Header,
        'v-footer': Footer,
        'v-logo': Logo,
        'v-nav': Nav,
        'v-breadcrumb': Breadcrumb,
    },
    methods: {
        ...mapActions(['setBreadcrumb']),
    },
    created() {
        this.$router.beforeEach((to, from, next) => {
            window.scrollTo(0, 0);
            if (!!to.meta.name && to.meta.name !== 'auto') {
                this.setBreadcrumb(to.name);
            }
            next();
        });
    },
};
</script>

<style lang="less">
html,
body {
    padding: 0;
    margin: 0;
    background-color: #f4f4f4;
}

* {
    box-sizing: border-box;
}

a {
    text-decoration: none;
}

.container {
    width: 1200px;
    margin: 0 auto;

    .el-button--success,
    .el-button--success:focus,
    .el-button--success:hover,
    .el-button--primary,
    .el-button--primary:focus,
    .el-button--primary:hover {
        background-color: #3c9539;
        border-color: #3c9539;
    }
}

.router-view {
    min-height: 100px;
}

table {
    border-collapse: collapse;
    border-spacing: 0;
    width: 100%;
    text-align: center;
    font-size: 14px;
}

table .th {
    height: 50px;
    line-height: 50px;
    color: #fff;
    font-size: 14px;
    margin-bottom: 23px;
    background-color: #3c9539;
}

table tr {
    height: 60px;
    margin-top: 10px;
    background-color: #fff;
}

.pagination {
    margin-top: 30px;
    text-align: center;
    .el-pagination.is-background .el-pager {
        li:not(.disabled).active {
            background-color: #3c9539;
        }
        li:not(.disabled):hover {
            color: #37923a;
        }
    }
}

.table-empty {
    width: 100%;
    margin: 50px auto;
    text-align: center;
    color: #999;
    padding-bottom: 10px;
    i {
        font-size: 60px;
    }
    p {
        font-size: 12px;
    }
}
</style>
